export enum BankState {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  PENDING = 'PENDING',
  REQUIRES_UPDATE = 'REQUIRES_UPDATE'
}

type BankDetails = {
  accountName: string
  accountNumber: string
  bankAccountType: string
  bankName: string
  bic: string
  iban: string
  media?: { source: string; type: string }[]
  routingNumber: string
  sortCode: string
}

type BaseBank =
  // Plaid bank data
  | {
      addedAt: string
      attributes?: {
        linkUrl: string
        link_token: string
        tokenExpiresAt: string
      }
      currency: string
      details: BankDetails | null
      id: string
      partner: 'PLAID'
    }
  // Yodlee bank data
  | {
      addedAt: string
      attributes?: FastlinkRequest & {
        tokenExpiresAt: string
      }
      currency: string
      details: BankDetails | null
      id: string
      partner: 'YODLEE'
    }
  // Yapily bank data
  | {
      addedAt: string
      attributes?: YapilyData
      currency: string
      details: BankDetails | null
      id: string
      partner: 'YAPILY'
    }

type BlockedBank = BaseBank & {
  error: string
  state: BankState.BLOCKED
}

type ActiveBank = BaseBank & {
  details: BankDetails
  state: BankState.ACTIVE
}

type UpdateBankRequired = BaseBank & {
  state: BankState.REQUIRES_UPDATE
}

type PendingBank = BaseBank & {
  state: BankState.PENDING
}

export type Bank = PendingBank | ActiveBank | BlockedBank | UpdateBankRequired

export type FastlinkRequest = {
  fastlinkParams: object
  fastlinkUrl: string
  token: string
}

type Media = { source: string; type: string }[]

export type YapilyInstitution = {
  fullName: string
  id: string
  media: Media
  name: string
}

export type YapilyData =
  | {
      authorisationUrl?: never
      entity: string
      institutions: YapilyInstitution[]
      media: never
      qrcodeUrl?: never
    }
  | {
      authorisationUrl: string
      entity: string
      institutions?: never
      media: Media
      qrcodeUrl: string
    }
